import React from "react";
import clsx from "clsx/lite";
import { Swiper, SwiperSlide } from "swiper/react";
import { useGlobalContext } from "context/global";
import Image from "components/image";

const ProgressTracker = ({ progress }) => {
	const { subscriptionRules: { rewardBannerSteps = [] }, translation } = useGlobalContext();
	if (!rewardBannerSteps.length) return null;

	const calculateWidth = (index) => {
		if (index < progress) return "100%";

		const difference = index - progress;

		if ((difference) < 1 && (difference) > 0) return `${(1 - difference) * 100}%`;

		return "100%";
	};

	return (
		<div className="lg:w-1/2 mt-5 lg:mt-0">
			<h3 className="text-lg font-boldParagraph mb-1">{translation.subscription.total_orders}</h3>
			<Swiper
				slidesPerView={4.1}
				preventClicksPropagation
				initialSlide={parseInt(progress) - 1}
				mousewheel
				draggable
				grabCursor
				breakpoints={{ 768: { slidesPerView: 4.3 } }}
			>
				{rewardBannerSteps.map((step, index) => (
					<SwiperSlide
						style={{ zIndex: rewardBannerSteps.length - index }}
						key={index} className={clsx("relative flex gap-x-0 items-stretch", index < progress - 1 && "-mr-px")}>
						<div className={clsx("h-4.5 w-full bg-white -mr-5", index === 0 && "rounded-l-full",
							index === rewardBannerSteps.length - 1 && "rounded-r-full")} />
						<div
							style={{ width: calculateWidth(index + 1) }}
							className={clsx("absolute h-4.5 bg-white w-full", index === 0 && "rounded-l-full",
								(index === rewardBannerSteps.length - 1 || index === progress - 1) && "rounded-r-full", 
								index < progress && "!bg-orange")}
						/>
						<div className={clsx("flex flex-col items-end relative w-fit max-h-12", index < progress - 1 && "pr-px")}>
							<span className="size-4.5 flex justify-center items-center rounded-full bg-beige border-2 text-small">
								{step.title}
							</span>
							<span className="text-lg mt-2 w-5"><Image image={step.icon} /></span>
						</div>
					</SwiperSlide>
				))}
			</Swiper>
		</div>
	);
};

export default ProgressTracker;
